export const COMPLETE = '#adc839';
export const COMPLETE_BORDER = '#8aa037';
export const INCOMPLETE = '#6f4c87';
export const INCOMPLETE_BORDER = '#493066';
